export class GameConstants {
    static readonly SCATTER_SYMBOL_ID = 12;
    static readonly RIP_SYMBOL_ID = 13;
    static FEATURE_NAME_MAP: Record<string, string> = {
        "Replicate": "Double",
        "Reinfest": "Multi",
        "Reawaken": "Extra"
    };
    static readonly BACKGROUND_SIZE = 2048;
    static readonly BACKGROUND_SIZE_HIGHER = 3000;
    static readonly GAME_RES_WIDTH = 1920;
    static readonly GAME_RES_HEIGHT = 1080;
    static readonly BIG_WIN_COUNTER_OFFSET = 265;
    // Symbol Ids for the features
    // static readonly REPLICATE_SYMBOL_ID = 111;
    // static readonly REINFEST_SYMBOL_ID = 112;
    // static readonly REAWAKEN_SYMBOL_ID = 113;
    // static readonly REPLICATE_REINFEST_SYMBOL_ID = 114;
    // static readonly REPLICATE_REAWAKEN_SYMBOL_ID = 115;
    // static readonly REINFEST_REAWAKEN_SYMBOL_ID = 116;
    // static readonly REPLICATE_REINFEST_REAWAKEN_SYMBOL_ID = 117;

    static readonly GOLD_COIN = 100;
    static readonly RIP_SYMBOL_MAP: Record<string, number> = {
        REPLICATE_SYMBOL_ID: 111,
        REINFEST_SYMBOL_ID: 112,
        REAWAKEN_SYMBOL_ID: 113,
        REPLICATE_REINFEST_SYMBOL_ID: 114,
        REPLICATE_REAWAKEN_SYMBOL_ID: 115,
        REINFEST_REAWAKEN_SYMBOL_ID: 116,
        REPLICATE_REINFEST_REAWAKEN_SYMBOL_ID: 117,
    };

}
